import React from 'react';
export function DescriptionSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10 mb-12" data-id="element-1772">
      <div className="max-w-4xl mx-auto space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-1773">
        <p data-id="element-1774">
          A 2-axis CNC cutting system that uses diamond-coated wire to cut
          non-conductive materials such as composites, graphite, ceramics,
          glass, and stone. The technology offers precise, economical cutting
          for materials that cannot be machined using EDM processes.
        </p>
      </div>
    </div>;
}